import { render, staticRenderFns } from "./form-email.vue?vue&type=template&id=62e724fe&"
import script from "./form-email.vue?vue&type=script&lang=js&"
export * from "./form-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports